import React from "react";
import LegalLayout from "../../components/LegalLayout";

const TeslimatPolitikasi = () => {
  return (
    <LegalLayout title="Teslimat ve Kargo Politikası">

      <h2>1. Sipariş Hazırlama Süreci</h2>

      <p>
        Siparişleriniz, ödeme işleminin başarıyla tamamlanmasının ardından
        hazırlanmaya başlanır. Siparişler, stok durumu ve operasyonel süreçler
        dikkate alınarak en kısa sürede kargoya teslim edilir.
      </p>

      <br />

      <h2>2. Teslimat Süresi</h2>

      <p>
        Siparişler normal şartlarda 1-5 iş günü içerisinde teslim edilmektedir.
      </p>

      <p>
        Resmi tatiller, yoğun kampanya dönemleri, hava koşulları, doğal afetler
        veya diğer mücbir sebepler nedeniyle teslimat sürelerinde gecikmeler
        yaşanabilir.
      </p>

      <br />

      <h2>3. Kargo İşlemleri</h2>

      <p>
        Ürünler, anlaşmalı kargo firmaları aracılığıyla sipariş sırasında
        belirtilen teslimat adresine gönderilmektedir.
      </p>

      <p>
        Kargo takip bilgileri, siparişiniz kargoya teslim edildikten sonra
        tarafınıza iletilebilir.
      </p>

      <br />

      <h2>4. Teslimat Sırasında Dikkat Edilmesi Gerekenler</h2>

      <p>
        Siparişinizi teslim alırken paketin dış ambalajını kontrol etmeniz
        tavsiye edilir.
      </p>

      <p>
        Paket üzerinde ezilme, yırtılma, ıslanma veya benzeri bir hasar
        bulunması halinde kargo görevlisine "Hasar Tespit Tutanağı"
        düzenlettirmeniz ve ürünü teslim almadan önce bizimle iletişime
        geçmeniz önemlidir.
      </p>

      <br />

      <h2>5. Yanlış veya Eksik Adres Bilgisi</h2>

      <p>
        Sipariş sırasında girilen teslimat bilgilerinin doğru ve eksiksiz
        olması müşterinin sorumluluğundadır.
      </p>

      <br />

      <h2>6. Teslim Edilemeyen Siparişler</h2>

      <p>
        Alıcının adreste bulunmaması, adres bilgilerinin hatalı olması veya
        siparişin teslim alınmaması durumunda ürün kargo firması tarafından
        iade edilebilir.
      </p>

      <p>
        Bu durumda müşteri hizmetlerimiz sizinle iletişime geçerek yeniden
        gönderim süreci hakkında bilgilendirme sağlayacaktır.
      </p>

      <br />

      <h2>7. Mücbir Sebepler</h2>

      <p>
        Doğal afetler, salgın hastalıklar, savaş, grev, ulaşım problemleri,
        resmi makam kararları ve tarafların kontrolü dışında gelişen diğer
        mücbir sebepler nedeniyle teslimat süreleri uzayabilir.
      </p>

      <br />

      <h2>8. İletişim</h2>

      <p>
        Teslimat ve kargo süreçleriyle ilgili her türlü soru ve talepleriniz
        için aşağıdaki iletişim bilgilerimizden bize ulaşabilirsiniz.
      </p>

      <ul>
        <li><strong>Şirket:</strong> One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.</li>
        <li><strong>Adres:</strong> Genç Osman Mahallesi Pınar Sokak No:9 Güngören / İstanbul</li>
        <li><strong>Telefon:</strong> +90 537 210 14 52</li>
        <li><strong>E-posta:</strong> goomoreinternational@gmail.com</li>
      </ul>

    </LegalLayout>
  );
};

export default TeslimatPolitikasi;